import React from 'react'
import TopicCardHeader from './TopicCardHeader'
import ResponseForm from './ResponseForm'
import TopicCardInfos from './TopicCardInfos'
import TopicCardDescription from './TopicCardDescription'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { Link } from 'react-router-dom'

const useStyles = makeStyles({
  root: {
    marginBottom: 30,
    borderRadius: 4,
    background: '#fff'
  },
  link: {
    textDecoration: 'none'
  },
  container: {
    paddingLeft: 69,
    paddingRight: 69,
    '@media only screen and (max-width: 1050px)': {
      paddingLeft: 20,
      paddingRight: 20
    }
  }
})

const TopicCard = ({
  _id,
  topico_id,
  category,
  title,
  curso_id,
  description,
  loading,
  visualizacoes,
  link = true,
  detail = false,
  createdAt,
  postadoPor,
  quantidadeRespostas,
  query,
  ...rest
}) => {
  const classes = useStyles()

  if (loading) {
    return (
      <Paper component={'article'} className={classes.root} elevation={2}>
        <TopicCardHeader loading={loading} categoryLabel={category} title={title} />
        <div className={classes.container}>
          <TopicCardDescription loading={loading}>{description}</TopicCardDescription>
          <TopicCardInfos loading={loading} visualizacoes={visualizacoes} />
        </div>
      </Paper>
    )
  }

  if (!_id) {
    return (
      <Paper component={'article'} className={classes.root} elevation={2}>
        <TopicCardHeader loading={loading} categoryLabel={category} title={'Tópico não encontrado.'} />
        <div className={classes.container}>
          <TopicCardDescription error={true} loading={loading}>
            Tópico não encontrado.
          </TopicCardDescription>
        </div>
      </Paper>
    )
  }

  if (detail) {
    return (
      <Paper component={'article'} className={classes.root} elevation={2}>
        <TopicCardHeader loading={loading} categoryLabel={category} title={title} />
        <div className={classes.container}>
          <TopicCardInfos
            deleteButton
            topico_id={topico_id}
            createdAt={createdAt}
            postadoPor={postadoPor}
            loading={loading}
            visualizacoes={visualizacoes}
          />
          <TopicCardDescription loading={loading}>{description}</TopicCardDescription>
          <ResponseForm query={query} topico_id={topico_id} curso_id={curso_id} />
        </div>
      </Paper>
    )
  }

  return (
    <Link className={classes.link} {...rest}>
      <Paper component={'article'} className={classes.root} elevation={2}>
        <TopicCardHeader loading={loading} categoryLabel={category} title={title} />
        <div className={classes.container}>
          <TopicCardDescription loading={loading}>{description}</TopicCardDescription>
          <TopicCardInfos
            topico_id={topico_id}
            quantidadeRespostas={quantidadeRespostas}
            postadoPor={postadoPor}
            createdAt={createdAt}
            loading={loading}
            visualizacoes={visualizacoes}
          />
        </div>
      </Paper>
    </Link>
  )
}
export default TopicCard
